module.exports = __webpack_public_path__ + "img/icon-whatsapp-white.1ae99534.svg";